/* eslint-disable no-param-reassign */

import LengthP2X from '../../lengthTypes/lengthP2X';
import LengthX from '../../lengthTypes/lengthX';
import LengthZ from '../../lengthTypes/lengthZ';
import MeshManage from '../../meshManage';
import TopPanel from '../../specialHandler/topPanel';
import {
  AXES_ENUM, BASICRENDER_TYPE, BASICTYPE_ENUM, LengthLocation, LengthType, CABINET_HEIGHT_TYPE,
} from '../../utils/enum';
import { FRAMEDEPTH, SKIRTINGBOARDCONFIG, TOPPANELCONFIG } from '../../utils/kitchenConfig';
import { getFramePositionInfo, getDividingPosition } from '../../utils/templatejsonUtils';
import {
  getLengthXTopPanel, getLengthZTopPanel, getLengthP2XTopPanel,
} from '../../heightSinkCabinet/renderUSinkCabinet';
// eslint-disable-next-line max-statements
function renderTopPanelUtil(renderUThis) {
  const topPanelTexture = renderUThis?.templateJson?.bottom?.topPanels[0].componentBasic?.modelUrl;
  let highSinkCabinetData = null;
  const isHighSinkCabinet = renderUThis?.templateJson?.bottom?.highAndLow || false; // 检查是否有高低柜
  if (isHighSinkCabinet) {
    highSinkCabinetData = getDividingPosition(renderUThis?.templateJson); // 获取高低柜分段点柜体数据
  }
  const l1HighSinkCabinetFrame = highSinkCabinetData?.l1Frame;
  const l2HighSinkCabinetFrame = highSinkCabinetData?.l2Frame;
  const l3HighSinkCabinetFrame = highSinkCabinetData?.l3Frame;
  const stovePositionInfo = { ...getFramePositionInfo(renderUThis?.templateJson, 'stove') };
  console.log(highSinkCabinetData, 'aaaaaaaaa');

  // L1边
  const topPanelArrLength1 = [];
  const lastFrame = renderUThis.templateJson.bottom.length1?.frames[
    renderUThis.templateJson.bottom.length1.frames.length - 1];

  const mesh = renderUThis.scene.getMeshByName(lastFrame.componentBasic.id);
  if (!mesh) {
    return;
  }
  // version 2.3 add by xiaohua.zhu 20220330 侧板对象结构有调整 需要判断版本
  const l1SidePlateDepth = renderUThis.getSidePlateDepth('length1');
  const bottomType = renderUThis.templateJson.bottom.type;

  // version 2.0, add by zhanyu.shen 20211221 begin, 获取底柜X轴补板尺寸，如果补板在柜子中间，该值为0
  let sealPlateSizeX = 0;
  // modify add by zhanyu.shen 20211227, 当顶柜有高柜，底柜和高柜需要补板填补空隙(比如L1底柜240顶柜307，L3底柜178)
  if (renderUThis.isSealPlateBeforeTopHightFrame(LengthType.Length1)
  || renderUThis.isSealPlateBeforeTopRefrigeraror(LengthType.Length1)) {
    sealPlateSizeX = renderUThis.getSealPlateSize(LengthLocation.Bottom, LengthType.Length1, AXES_ENUM.x);
  } else {
    sealPlateSizeX = renderUThis.getSealPlateSizeOnlyOneFrame(LengthLocation.Bottom, LengthType.Length1, AXES_ENUM.x);
  }
  // add by zhanyu.shen 20211221 end

  const lastMeshManage = new MeshManage(mesh);
  const length1Configs = lastMeshManage.getLengthXConfigs(sealPlateSizeX + l1SidePlateDepth);
  // 台面
  let Length1BottomHeight = renderUThis.templateJson.bottom.height;
  if (isHighSinkCabinet) {
    // 根据L2边上高低柜断点判断L1是全高柜（80高度）还是全低柜（70高度）
    // 高低柜分段点在L3边且isAfterDirection === true L1全低, L1=88 L2=216 L3=158, 灶台在L2水槽在L3
    if (l3HighSinkCabinetFrame?.frameInfo && l3HighSinkCabinetFrame?.isAfterDirection === true) {
      Length1BottomHeight = CABINET_HEIGHT_TYPE.Seventy;
    }
    // L1=88 L2=216 L3=158, 灶台在L3水槽在L2
    if (l3HighSinkCabinetFrame?.frameInfo && l3HighSinkCabinetFrame?.isAfterDirection === false) {
      Length1BottomHeight = CABINET_HEIGHT_TYPE.Eighty;
    }
    // 高低柜分段点在L2边且isAfterDirection === true L1全低
    if (l2HighSinkCabinetFrame?.frameInfo && l2HighSinkCabinetFrame?.isAfterDirection === true) {
      Length1BottomHeight = CABINET_HEIGHT_TYPE.Seventy;
    }
    // 高低柜分段点在L2边且isAfterDirection === false L1全高
    if (l2HighSinkCabinetFrame?.frameInfo && l2HighSinkCabinetFrame?.isAfterDirection === false) {
      Length1BottomHeight = CABINET_HEIGHT_TYPE.Eighty;
    }
  }
  const position = {
    x: length1Configs.centerPoint,
    y: Length1BottomHeight * 0.01 + SKIRTINGBOARDCONFIG.HEIGHT + TOPPANELCONFIG.HEIGHT / 2,
    z: FRAMEDEPTH.BOTTOM / 2 + TOPPANELCONFIG.DEPTH / 2,
  };
  const size = {
    width: length1Configs.length,
    height: TOPPANELCONFIG.HEIGHT,
    depth: FRAMEDEPTH.BOTTOM + TOPPANELCONFIG.DEPTH,
  };
  if (isHighSinkCabinet && l1HighSinkCabinetFrame && l1HighSinkCabinetFrame.frameInfo) {
    // L1 台面有高低柜分段点
    const topPanelInfoArr = getLengthXTopPanel(renderUThis, l1HighSinkCabinetFrame, length1Configs.length);
    topPanelInfoArr.forEach((item) => {
      const tempTopPanel = new TopPanel(renderUThis.scene, item.position, item.size, true);
      tempTopPanel.createTopPanel(topPanelTexture);
      topPanelArrLength1.push(tempTopPanel);
    });
  } else {
    const topPanel = new TopPanel(renderUThis.scene, position, size, true);
    topPanel.createTopPanel(topPanelTexture);
    topPanelArrLength1.push(topPanel);
  }
  const lastTopPanelLength1 = topPanelArrLength1[topPanelArrLength1.length - 1];
  // 如果有高柜，高柜位置挖洞
  if (renderUThis.highFrameMesh && renderUThis.highFrameMeshLocation === 1) {
    // version 2.0 modify by zhanyu.shen 20220104 begin 将多个高柜作为一个整体获取中心坐标和尺寸
    // const highFrameMeshBounds = renderUThis.highFrameMesh.getHierarchyBoundingVectors();
    // 2.3高柜新增一块侧板 台面挖洞需要相应调整
    // 侧板内侧的侧板厚度 2.3版本前无内侧侧板
    const l1HighFrameFirstSidePlateHoleDepth = renderUThis.templateJson.version > '2.2' ? l1SidePlateDepth : 0;
    const highFrameData = renderUThis.getHighFrameGroupPositionAndSize(
      BASICTYPE_ENUM.bottom, LengthType.Length1,
    );
    const holePosition = {
      x: highFrameData?.position?.x - TOPPANELCONFIG.DEPTH / 2 + l1HighFrameFirstSidePlateHoleDepth / 2,
      // y: position.y,
      y: lastTopPanelLength1.position.y,
      // z: position.z + TOPPANELCONFIG.DEPTH / 2,
      z: lastTopPanelLength1.position.z + TOPPANELCONFIG.DEPTH / 2,
    };
    const holeSize = {
      width: highFrameData?.size?.x + TOPPANELCONFIG.DEPTH + l1HighFrameFirstSidePlateHoleDepth,
      height: TOPPANELCONFIG.HEIGHT,
      // depth: size.depth + TOPPANELCONFIG.DEPTH,
      depth: lastTopPanelLength1.size.depth + TOPPANELCONFIG.DEPTH,
    };
    // modify by zhanyu.shen 20220104 end
    lastTopPanelLength1.createHoleTopPanel(holePosition, holeSize, topPanelTexture);
  }
  // renderUThis.addMesh(lastTopPanelLength1.mesh);
  topPanelArrLength1.forEach((item) => {
    renderUThis.addMesh(item.mesh);
  });

  // L2边 有可能存在l2frames为空
  const topPanelArrLength2 = [];
  let lastFrame2 = renderUThis.templateJson.bottom.length2?.frames[
    renderUThis.templateJson.bottom.length2.frames.length - 1];
  if (!lastFrame2) {
    lastFrame2 = renderUThis.templateJson.bottom.length1?.frames[0];
  }

  const mesh2 = renderUThis.scene.getMeshByName(lastFrame2.componentBasic.id);
  const lastMeshManage2 = new MeshManage(mesh2);
  const length2Configs = lastMeshManage2.getLengthZConfigs();

  let sealPlateSizeZ = 0;
  if (bottomType === BASICRENDER_TYPE.U_S) {
    sealPlateSizeZ = renderUThis.getSealPlateSizeOnlyOneFrame(LengthLocation.Bottom, LengthType.Length2, AXES_ENUM.z);
  }

  // L2台面
  let Length2BottomHeight = renderUThis.templateJson.bottom.height;
  if (isHighSinkCabinet) {
    // 高低柜分段点在L1边且isAfterDirection === false（高台面在U型L2边）L2全高
    if (l1HighSinkCabinetFrame?.frameInfo && l1HighSinkCabinetFrame?.isAfterDirection === false) {
      Length2BottomHeight = CABINET_HEIGHT_TYPE.Eighty;
    }
    // 高低柜分段点在L3边且isAfterDirection === false（高台面在U型L2边）L2全高
    if (l3HighSinkCabinetFrame?.frameInfo && l3HighSinkCabinetFrame?.isAfterDirection === false) {
      Length2BottomHeight = CABINET_HEIGHT_TYPE.Eighty;
    }
    // 高低柜分段点在L3边且isAfterDirection === true（高台面只在U型L3边，此时水槽在L3灶台在L2）L2全低
    if (l3HighSinkCabinetFrame?.frameInfo && l3HighSinkCabinetFrame?.isAfterDirection === true) {
      Length2BottomHeight = CABINET_HEIGHT_TYPE.Seventy;
    }
  }
  const position2 = {
    x: -FRAMEDEPTH.BOTTOM / 2 - TOPPANELCONFIG.DEPTH / 2,
    y: Length2BottomHeight * 0.01 + SKIRTINGBOARDCONFIG.HEIGHT + TOPPANELCONFIG.HEIGHT / 2,
    z: length2Configs.centerPoint + TOPPANELCONFIG.DEPTH / 2 + FRAMEDEPTH.BOTTOM / 2 + sealPlateSizeZ / 2,
  };
  const size2 = {
    width: FRAMEDEPTH.BOTTOM + TOPPANELCONFIG.DEPTH,
    height: TOPPANELCONFIG.HEIGHT,
    depth: length2Configs.length - TOPPANELCONFIG.DEPTH - FRAMEDEPTH.BOTTOM + sealPlateSizeZ,
  };
  // const topPanel2 = new TopPanel(renderUThis.scene, position2, size2, null);
  // topPanel2.createTopPanel(topPanelTexture);
  // renderUThis.addMesh(topPanel2.mesh);
  if (isHighSinkCabinet && l2HighSinkCabinetFrame && l2HighSinkCabinetFrame.frameInfo) {
    // L2 台面有高低柜分段点
    const topPanelInfoArr = getLengthZTopPanel(renderUThis, l2HighSinkCabinetFrame, length2Configs.length);
    topPanelInfoArr.forEach((item) => {
      const tempTopPanel = new TopPanel(renderUThis.scene, item.position, item.size, true);
      tempTopPanel.createTopPanel(topPanelTexture);
      topPanelArrLength2.push(tempTopPanel);
    });
  } else {
    const topPanel2 = new TopPanel(renderUThis.scene, position2, size2, null);
    topPanel2.createTopPanel(topPanelTexture);
    topPanelArrLength2.push(topPanel2);
  }
  // L1边有水槽的台面，非高低柜就一块，高低柜时高台面在第一块（水槽在高台面）
  let length2SinkTopPanel = topPanelArrLength2[0];
  if (l2HighSinkCabinetFrame && l2HighSinkCabinetFrame.frameInfo && l2HighSinkCabinetFrame.isAfterDirection === true) {
    // L2右低左高，水槽挖洞台面在最后一块
    length2SinkTopPanel = topPanelArrLength2[topPanelArrLength2.length - 1];
  }
  topPanelArrLength2.forEach((item) => {
    renderUThis.addMesh(item.mesh);
  });


  /* -----------------------隐藏l3的时候需要展示的台面------------------  */
  // l2设置三块板子为了显示控制U型的显隐
  const hasLength2 = renderUThis.templateJson.bottom.length2?.frames; // L2是否只有转角柜
  let lastFrameHideL3;
  // 有可能存在l2frames为空
  if (hasLength2.length === 1 || hasLength2.length === 0) { // L2上只有一个转角柜的时候
    lastFrameHideL3 = hasLength2[hasLength2.length - 1];
  } else {
    lastFrameHideL3 = hasLength2[hasLength2.length - 2];
  }

  let meshHideL3;
  let lastMeshManageHideL3;
  let length2ConfigsHideL3;
  if (hasLength2.length === 1 || hasLength2.length === 0) { // length2只有一个转角柜
    lastFrameHideL3 = renderUThis.templateJson.bottom.length1?.frames[0];
    meshHideL3 = renderUThis.scene.getMeshByName(lastFrameHideL3.componentBasic.id);
    lastMeshManageHideL3 = new MeshManage(meshHideL3);
    length2ConfigsHideL3 = lastMeshManageHideL3.getLengthZConfigs();
  } else {
    meshHideL3 = renderUThis.scene.getMeshByName(lastFrameHideL3.componentBasic.id);
    lastMeshManageHideL3 = new MeshManage(meshHideL3);
    length2ConfigsHideL3 = lastMeshManageHideL3.getLengthZConfigs();
  }
  const positionHideL3 = {
    x: -FRAMEDEPTH.BOTTOM / 2 - TOPPANELCONFIG.DEPTH / 2,
    // y: renderUThis.templateJson.bottom.height * 0.01 + SKIRTINGBOARDCONFIG.HEIGHT + TOPPANELCONFIG.HEIGHT / 2,
    y: Length2BottomHeight * 0.01 + SKIRTINGBOARDCONFIG.HEIGHT + TOPPANELCONFIG.HEIGHT / 2,
    z: length2ConfigsHideL3.centerPoint + TOPPANELCONFIG.DEPTH / 2 + FRAMEDEPTH.BOTTOM / 2,
  };
  const sizeHideL3 = {
    width: FRAMEDEPTH.BOTTOM + TOPPANELCONFIG.DEPTH,
    height: TOPPANELCONFIG.HEIGHT,
    depth: length2ConfigsHideL3.length - TOPPANELCONFIG.DEPTH - FRAMEDEPTH.BOTTOM,
  };
  const hideL3sinkPositionInfo = { ...getFramePositionInfo(renderUThis?.templateJson, 'sink') };
  if (l2HighSinkCabinetFrame?.frameInfo && l2HighSinkCabinetFrame?.isAfterDirection === false) {
    if ((hideL3sinkPositionInfo.location === 2 && stovePositionInfo?.location === 3) || (
      bottomType === BASICRENDER_TYPE.U && hideL3sinkPositionInfo.location === 1 && stovePositionInfo?.location === 3
    )) {
      // L1=238, L2=228, L3=168, 高低台面, 水槽在L2, 灶台在L3, 分段点在L2边左低右高，旋转隐藏L3边时L2只需显示水槽所在高台面
      // L1=238, L2=208, L3=128, 灶台在L3, 水槽在L1（或者L1=238, L2=228, L3=168）
      positionHideL3.y = CABINET_HEIGHT_TYPE.Eighty * 0.01 + SKIRTINGBOARDCONFIG.HEIGHT + TOPPANELCONFIG.HEIGHT / 2;
    }
    if (hideL3sinkPositionInfo.location === 1 && stovePositionInfo?.location === 2
      && bottomType === BASICRENDER_TYPE.U) {
      // L1=238, L2=300, L3=238, 高低台面,高低台面, 水槽在L1, 灶台在L2, 分段点在L2边左低右高, 旋转隐藏L3边时L2只需调整最后一块低台面尺寸
      const extraTopPanelLength2 = topPanelArrLength2[1]; // L2边高低台面分段点
      positionHideL3.y = CABINET_HEIGHT_TYPE.Seventy * 0.01 + SKIRTINGBOARDCONFIG.HEIGHT + TOPPANELCONFIG.HEIGHT / 2;
      positionHideL3.z = (length2ConfigsHideL3.length + extraTopPanelLength2.position.z
         - extraTopPanelLength2.size.depth / 2) / 2;
      sizeHideL3.depth = length2ConfigsHideL3.length - (extraTopPanelLength2.position.z
         - extraTopPanelLength2.size.depth / 2);
    }
    if (hideL3sinkPositionInfo.location === 1 && stovePositionInfo?.location === 2
      && bottomType === BASICRENDER_TYPE.U_S) {
      // L1=238, L2=196, L3=238, 灶台在L2，水槽在L1，L2左低右高, L3是40深窄柜
      positionHideL3.y = CABINET_HEIGHT_TYPE.Eighty * 0.01 + SKIRTINGBOARDCONFIG.HEIGHT + TOPPANELCONFIG.HEIGHT / 2;
    }
  }
  if (bottomType === BASICRENDER_TYPE.U
    && l2HighSinkCabinetFrame?.frameInfo && l2HighSinkCabinetFrame.isAfterDirection === true
    && ((hideL3sinkPositionInfo.location === 2 && stovePositionInfo?.location === 1) || (
      hideL3sinkPositionInfo.location === 3 && stovePositionInfo?.location === 1 && hasLength2.length > 1
    ))) {
    // L1=168, L2=300, L3=238, 灶台在L1，水槽在L2
    // L1=168, L2=300, L3=238, 灶台在L1，水槽在L3,  L2边至少两个柜体(或 L1=168, L2=228, L3=238)
    const extraTopPanelLength2 = topPanelArrLength2[1]; // L2边高低台面分段点
    positionHideL3.y = CABINET_HEIGHT_TYPE.Eighty * 0.01 + SKIRTINGBOARDCONFIG.HEIGHT + TOPPANELCONFIG.HEIGHT / 2;
    positionHideL3.z = (length2ConfigsHideL3.length + extraTopPanelLength2.position.z
         - extraTopPanelLength2.size.depth / 2) / 2;
    sizeHideL3.depth = length2ConfigsHideL3.length - (extraTopPanelLength2.position.z
         - extraTopPanelLength2.size.depth / 2);
  }
  const topPaneHideL3 = new TopPanel(renderUThis.scene, positionHideL3, sizeHideL3, null);
  topPaneHideL3.createTopPanel(topPanelTexture);
  renderUThis.addMesh(topPaneHideL3.mesh);

  if (hideL3sinkPositionInfo.id && hideL3sinkPositionInfo.location === 2) { // 水槽在L2上需要挖洞
    const hideL3tempLengthClass = new LengthZ(renderUThis.templateJson, renderUThis.scene);
    const hideL3tmpHoleInfo = hideL3tempLengthClass.getSinkHolePosition(
      hideL3sinkPositionInfo.cabinetId,
      hideL3sinkPositionInfo.id,
      // position2.y,
      length2SinkTopPanel.position.y,
      hideL3sinkPositionInfo.cornerCabinetDirection,
      hideL3sinkPositionInfo.frameInfo,
    );
    hideL3tempLengthClass.createHole(hideL3tmpHoleInfo.holePosition, hideL3tmpHoleInfo.holeSize, topPanelTexture,
      topPaneHideL3, hideL3sinkPositionInfo.frameInfo.componentBasic.componentId);
  }

  topPaneHideL3?.mesh?.setEnabled(false);

  /* -----------------------隐藏l1的时候需要展示的台面------------------  */
  // l2设置三块板子为了显示控制U型的显隐
  // 有可能存在l2frames为空
  let l1LastFrameHideL1 = renderUThis.templateJson.bottom.length2?.frames[0]; //  l1的第一个转角柜

  if (!l1LastFrameHideL1) {
    l1LastFrameHideL1 = renderUThis.templateJson.bottom.length1?.frames[0];
  }
  let lastFrameHideL1 = renderUThis.templateJson.bottom.length2?.frames[
    renderUThis.templateJson.bottom.length2.frames.length - 1
  ];
  if (!lastFrameHideL1) {
    lastFrameHideL1 = renderUThis.templateJson.bottom.length1?.frames[0];
  }
  const l1MeshHideL1 = renderUThis.scene.getMeshByName(l1LastFrameHideL1.componentBasic.id);
  const l2MeshHideL1 = renderUThis.scene.getMeshByName(lastFrameHideL1.componentBasic.id);
  const l1MeshManageHideL1 = new MeshManage(l1MeshHideL1);
  const l2MeshManageHideL1 = new MeshManage(l2MeshHideL1);
  const l2ConfigsHideL1 = l2MeshManageHideL1.getLengthZConfigs();

  const positionHideL1 = {
    x: -FRAMEDEPTH.BOTTOM / 2 - TOPPANELCONFIG.DEPTH / 2,
    // y: renderUThis.templateJson.bottom.height * 0.01 + SKIRTINGBOARDCONFIG.HEIGHT + TOPPANELCONFIG.HEIGHT / 2,
    y: Length2BottomHeight * 0.01 + SKIRTINGBOARDCONFIG.HEIGHT + TOPPANELCONFIG.HEIGHT / 2,
    z: (l2MeshManageHideL1.bounding.max.z + l1MeshManageHideL1.bounding.min.z) / 2,
  };
  const sizeHideL1 = {
    width: FRAMEDEPTH.BOTTOM + TOPPANELCONFIG.DEPTH,
    height: TOPPANELCONFIG.HEIGHT,
    depth: l2ConfigsHideL1.length - l1MeshManageHideL1.bounding.min.z,
  };
  const hideL1sinkPositionInfo = { ...getFramePositionInfo(renderUThis?.templateJson, 'sink') };
  if ((l2HighSinkCabinetFrame?.frameInfo && l2HighSinkCabinetFrame?.isAfterDirection === true
    && hideL1sinkPositionInfo.location === 3 && stovePositionInfo?.location === 2) || (
    l2HighSinkCabinetFrame?.frameInfo && l2HighSinkCabinetFrame?.isAfterDirection === false
      && hideL1sinkPositionInfo.location === 2 && stovePositionInfo?.location === 3
  ) || (l2HighSinkCabinetFrame?.frameInfo && l2HighSinkCabinetFrame?.isAfterDirection === false
    && hideL1sinkPositionInfo.location === 1 && stovePositionInfo?.location === 3 && hasLength2.length > 1)) {
    // L1=168, L2=238, L3=238, 高低台面，水槽在L3，灶台在L2
    // 或者 L1=238, L2=238, L3=168, 高低台面，水槽在L2，灶台在L3
    // L1=168, L2=238, L3=168, 水槽在L1，灶台在L3, L2边至少两个柜体
    const extraTopPanelLength2 = topPanelArrLength2[1]; // L2边高低台面分段点
    positionHideL1.z = (extraTopPanelLength2.position.z
      + extraTopPanelLength2.size.depth / 2 + l1MeshManageHideL1.bounding.min.z) / 2;
    if (l2HighSinkCabinetFrame?.isAfterDirection === false) {
      positionHideL1.y = CABINET_HEIGHT_TYPE.Eighty * 0.01 + SKIRTINGBOARDCONFIG.HEIGHT + TOPPANELCONFIG.HEIGHT / 2;
    }
    sizeHideL1.depth = extraTopPanelLength2.position.z
    + extraTopPanelLength2.size.depth / 2 - l1MeshManageHideL1.bounding.min.z;
  }
  if (l2HighSinkCabinetFrame?.frameInfo && l2HighSinkCabinetFrame?.isAfterDirection === true
     && stovePositionInfo?.location === 1) {
    positionHideL1.y = CABINET_HEIGHT_TYPE.Eighty * 0.01 + SKIRTINGBOARDCONFIG.HEIGHT + TOPPANELCONFIG.HEIGHT / 2;
  }
  const topPaneHideL1 = new TopPanel(renderUThis.scene, positionHideL1, sizeHideL1, null);
  topPaneHideL1.createTopPanel(topPanelTexture);
  renderUThis.addMesh(topPaneHideL1.mesh);

  if (hideL1sinkPositionInfo.id && hideL1sinkPositionInfo.location === 2) { // 水槽在L2上需要挖洞
    const hideL1tempLengthClass = new LengthZ(renderUThis.templateJson, renderUThis.scene);
    const hideL1tmpHoleInfo = hideL1tempLengthClass.getSinkHolePosition(
      hideL1sinkPositionInfo.cabinetId,
      hideL1sinkPositionInfo.id,
      // position2.y,
      length2SinkTopPanel.position.y,
      hideL1sinkPositionInfo.cornerCabinetDirection,
      hideL1sinkPositionInfo.frameInfo,
    );
    hideL1tempLengthClass.createHole(hideL1tmpHoleInfo.holePosition, hideL1tmpHoleInfo.holeSize, topPanelTexture,
      topPaneHideL1, hideL1sinkPositionInfo.frameInfo.componentBasic.componentId);
  }

  topPaneHideL1?.mesh?.setEnabled(false);

  // L3边
  let lastFrame3 = renderUThis.templateJson.bottom.length3?.frames[
    renderUThis.templateJson.bottom.length3.frames.length - 1];
  lastFrame3 = lastFrame3
      || renderUThis.templateJson.bottom.length2?.frames[renderUThis.templateJson.bottom.length2.frames.length - 1];
  const mesh3 = renderUThis.scene.getMeshByName(lastFrame3.componentBasic.id);
  const meshManage3 = new MeshManage(mesh3);
  const meshsize3 = meshManage3.getModelSize();

  // version 2.3 add by xiaohua.zhu 20220330 侧板对象结构有调整 需要判断版本
  const l3SidePlateDepth = renderUThis.getSidePlateDepth('length3');

  // version 2.0, add by zhanyu.shen 20211221 begin, 获取底柜平行X轴补板尺寸，如果补板在柜子中间，该值为0，如果length3边有柜子该值为0
  let sealPlateSizePX = 0;
  // modify add by zhanyu.shen 20211227, 当顶柜有高柜，底柜和高柜需要补板填补空隙
  if (renderUThis.isSealPlateBeforeTopHightFrame(LengthType.Length3)
  || renderUThis.isSealPlateBeforeTopRefrigeraror(LengthType.Length3)) {
    sealPlateSizePX = renderUThis.getSealPlateSize(LengthLocation.Bottom, LengthType.Length3, AXES_ENUM.x);
  } else {
    sealPlateSizePX = renderUThis.getSealPlateSizeOnlyOneFrame(LengthLocation.Bottom, LengthType.Length3, AXES_ENUM.x);
  }
  // add by zhanyu.shen 20211221 end

  // L3台面
  const topPanelArrLength3 = [];
  let Length3BottomHeight = renderUThis.templateJson.bottom.height;
  if (isHighSinkCabinet) {
    // 高低柜分段点在L1边且isAfterDirection === false L3全高
    if (l1HighSinkCabinetFrame?.frameInfo && l1HighSinkCabinetFrame?.isAfterDirection === false) {
      Length3BottomHeight = CABINET_HEIGHT_TYPE.Eighty;
    }
    // 高低柜分段点在L2边且isAfterDirection === false L3全低
    if (l2HighSinkCabinetFrame?.frameInfo && l2HighSinkCabinetFrame?.isAfterDirection === false) {
      Length3BottomHeight = CABINET_HEIGHT_TYPE.Seventy;
    }
    // 高低柜分段点在L3边且isAfterDirection === true L3全高
    if (l2HighSinkCabinetFrame?.frameInfo && l2HighSinkCabinetFrame?.isAfterDirection === true) {
      Length3BottomHeight = CABINET_HEIGHT_TYPE.Eighty;
    }
  }
  const position3 = {
    x: (mesh3.position.x - (meshsize3.x / 2)) / 2 - TOPPANELCONFIG.DEPTH / 2
        - FRAMEDEPTH.BOTTOM / 2 - l3SidePlateDepth / 2 - sealPlateSizePX / 2,
    y: Length3BottomHeight * 0.01 + SKIRTINGBOARDCONFIG.HEIGHT + TOPPANELCONFIG.HEIGHT / 2,
    z: meshsize3.z / 2 + mesh3.position.z - TOPPANELCONFIG.DEPTH / 2 - FRAMEDEPTH.BOTTOM / 2,
  };
  const size3 = {
    width: -mesh3.position.x + (meshsize3.x / 2)
        - TOPPANELCONFIG.DEPTH - FRAMEDEPTH.BOTTOM + l3SidePlateDepth + sealPlateSizePX,
    height: TOPPANELCONFIG.HEIGHT,
    depth: TOPPANELCONFIG.DEPTH + FRAMEDEPTH.BOTTOM,
  };
  let topPaneUSHideL3 = null;
  if (bottomType === BASICRENDER_TYPE.U_S) {
    position3.x = (mesh3.position.x - (meshsize3.x / 2)) / 2 - l3SidePlateDepth / 2 - sealPlateSizePX / 2;
    position3.z = meshsize3.z / 2 + mesh3.position.z - TOPPANELCONFIG.DEPTH / 2 - FRAMEDEPTH.USBOTTOM / 2;
    size3.width = -mesh3.position.x + (meshsize3.x / 2) + l3SidePlateDepth + sealPlateSizePX;
    size3.depth = TOPPANELCONFIG.DEPTH + FRAMEDEPTH.USBOTTOM;

    // U型L3边为40深, 创建L3正面视角显示的台面
    const firstFrame3 = renderUThis.templateJson.bottom.length3?.frames[0];
    if (firstFrame3) {
      const firstFrameMesh3 = renderUThis.scene.getMeshByName(firstFrame3.componentBasic.id);
      const firstFrameMeshManage3 = new MeshManage(firstFrameMesh3);
      const firstFrameMeshsize3 = firstFrameMeshManage3.getModelSize();
      const usHideL3PositionX = ((firstFrameMesh3.position.x + (firstFrameMeshsize3.x / 2))
        + (mesh3.position.x - (meshsize3.x / 2))) / 2;
      const usHideL3Position = {
        x: usHideL3PositionX - l3SidePlateDepth / 2 - sealPlateSizePX / 2,
        // y: renderUThis.templateJson.bottom.height * 0.01 + SKIRTINGBOARDCONFIG.HEIGHT + TOPPANELCONFIG.HEIGHT / 2,
        y: Length3BottomHeight * 0.01 + SKIRTINGBOARDCONFIG.HEIGHT + TOPPANELCONFIG.HEIGHT / 2,
        z: meshsize3.z / 2 + mesh3.position.z - TOPPANELCONFIG.DEPTH / 2 - FRAMEDEPTH.USBOTTOM / 2,
      };
      const usHideL3SizeWidth = Math.abs(mesh3.position.x - (meshsize3.x / 2))
        - Math.abs(firstFrameMesh3.position.x + (firstFrameMeshsize3.x / 2));
      const usHideL3Size = {
        width: Math.abs(usHideL3SizeWidth) + l3SidePlateDepth + sealPlateSizePX,
        height: TOPPANELCONFIG.HEIGHT,
        depth: TOPPANELCONFIG.DEPTH + FRAMEDEPTH.USBOTTOM,
      };
      topPaneUSHideL3 = new TopPanel(renderUThis.scene, usHideL3Position, usHideL3Size, null);
      topPaneUSHideL3.createTopPanel(topPanelTexture);
      renderUThis.addMesh(topPaneUSHideL3.mesh);
      topPaneUSHideL3?.mesh?.setEnabled(false);
    }
  }

  // const topPanel3 = new TopPanel(renderUThis.scene, position3, size3, true);
  // topPanel3.createTopPanel(topPanelTexture);
  if (isHighSinkCabinet && l3HighSinkCabinetFrame && l3HighSinkCabinetFrame.frameInfo) {
    // L3 台面有高低柜分段点
    const length3Configs = meshManage3.getLengthXConfigs(sealPlateSizePX + l3SidePlateDepth);
    const topPanelInfoArr = getLengthP2XTopPanel(renderUThis, l3HighSinkCabinetFrame, length3Configs.length);
    topPanelInfoArr.forEach((item) => {
      const tempTopPanel = new TopPanel(renderUThis.scene, item.position, item.size, true);
      tempTopPanel.createTopPanel(topPanelTexture);
      topPanelArrLength3.push(tempTopPanel);
    });
  } else {
    const topPanel3 = new TopPanel(renderUThis.scene, position3, size3, true);
    topPanel3.createTopPanel(topPanelTexture);
    topPanelArrLength3.push(topPanel3);
  }
  // L2边有水槽的台面，非高低柜就一块，高低柜时高台面在第一块（水槽在高台面）
  const lastTopPanelLength3 = topPanelArrLength3[topPanelArrLength3.length - 1];

  // 如果有高柜，高柜位置挖洞
  if (renderUThis.highFrameMesh && renderUThis.highFrameMeshLocation === 3) {
    // version 2.0 modify by zhanyu.shen 20220104 begin 将多个高柜作为一个整体获取中心坐标和尺寸
    // const highFrameMeshBounds = renderUThis.highFrameMesh.getHierarchyBoundingVectors();
    // 2.3高柜新增一块侧板 台面挖洞需要相应调整
    // 侧板内侧的侧板厚度 2.3版本前无内侧侧板
    const l3HighFrameFirstSidePlateHoleDepth = renderUThis.templateJson.version > '2.2' ? l3SidePlateDepth : 0;
    const highFrameData = renderUThis.getHighFrameGroupPositionAndSize(
      BASICTYPE_ENUM.bottom, LengthType.Length3,
    );
    const holePosition = {
      x: highFrameData?.position?.x - TOPPANELCONFIG.DEPTH / 2 + l3HighFrameFirstSidePlateHoleDepth / 2,
      // y: position3.y,
      y: lastTopPanelLength3.position.y,
      // z: position3.z - TOPPANELCONFIG.DEPTH / 2,
      z: lastTopPanelLength3.position.z - TOPPANELCONFIG.DEPTH / 2,
    };
    const holeSize = {
      width: highFrameData?.size?.x + TOPPANELCONFIG.DEPTH + l3HighFrameFirstSidePlateHoleDepth,
      height: TOPPANELCONFIG.HEIGHT,
      // depth: size3.depth + TOPPANELCONFIG.DEPTH,
      depth: lastTopPanelLength3.size.depth + TOPPANELCONFIG.DEPTH,
    };
      // modify by zhanyu.shen 20220104 end
    // topPanel3.createHoleTopPanel(holePosition, holeSize, topPanelTexture);
    lastTopPanelLength3.createHoleTopPanel(holePosition, holeSize, topPanelTexture);
  }
  // version2.0  U型柜添加水槽
  const sinkPositionInfo = { ...getFramePositionInfo(renderUThis?.templateJson, 'sink') };
  // 如果水槽存在判断在哪个边上面 然后进行挖孔
  if (sinkPositionInfo.id) {
    let tempLengthClass;
    let tmpHoleInfo;
    let tmpTopPanel;
    if (sinkPositionInfo.location === 1) {
      tempLengthClass = new LengthX(renderUThis.templateJson, renderUThis.scene);
      tmpHoleInfo = tempLengthClass.getSinkHolePosition(
        sinkPositionInfo.cabinetId,
        sinkPositionInfo.id,
        // position.y,
        lastTopPanelLength1.position.y,
        sinkPositionInfo.cornerCabinetDirection,
        sinkPositionInfo.frameInfo,
      );
      // tmpTopPanel = topPanel;
      tmpTopPanel = lastTopPanelLength1;
    } else if (sinkPositionInfo.location === 2) {
      tempLengthClass = new LengthZ(renderUThis.templateJson, renderUThis.scene);
      tmpHoleInfo = tempLengthClass.getSinkHolePosition(
        sinkPositionInfo.cabinetId,
        sinkPositionInfo.id,
        // position2.y,
        length2SinkTopPanel.position.y,
        sinkPositionInfo.cornerCabinetDirection,
        sinkPositionInfo.frameInfo,
      );
      tmpTopPanel = length2SinkTopPanel;
    } else if (sinkPositionInfo.location === 3) {
      tempLengthClass = new LengthP2X(renderUThis.templateJson, renderUThis.scene);
      tmpHoleInfo = tempLengthClass.getSinkHolePosition(
        sinkPositionInfo.cabinetId,
        sinkPositionInfo.id,
        // position3.y,
        lastTopPanelLength3.position.y,
        sinkPositionInfo.cornerCabinetDirection,
        sinkPositionInfo.frameInfo,
      );
      // tmpTopPanel = topPanel3;
      tmpTopPanel = lastTopPanelLength3;
    }

    const { holePosition, holeSize } = tmpHoleInfo;

    tempLengthClass?.createHole(holePosition, holeSize, topPanelTexture,
      tmpTopPanel, sinkPositionInfo.frameInfo.componentBasic.componentId);
  }
  // topPaneHideL1  隐藏l1时需要展示的台面 topPaneHideL3   隐藏l3时需要展示的台面
  // topPaneUSHideL3 L3为40深，隐藏l1时需要展示的台面
  // renderUThis.addMesh(topPanel3.mesh);
  topPanelArrLength3[topPanelArrLength3.length - 1] = lastTopPanelLength3;
  topPanelArrLength1.forEach((item) => {
    renderUThis.topPanelMesh.push(item.mesh);
    renderUThis.topPanelObjs.push(item);
  });
  topPanelArrLength2.forEach((item) => {
    renderUThis.topPanelMesh.push(item.mesh);
    renderUThis.topPanelObjs.push(item);
  });
  topPanelArrLength3.forEach((item) => {
    renderUThis.addMesh(item.mesh);
    renderUThis.topPanelMesh.push(item.mesh);
    renderUThis.topPanelObjs.push(item);
  });
  // XNeddHideMesh II型及U型柜隐藏l1的时候需要隐藏的mesh数组
  // P2XNeddHideMesh I型及U型柜隐藏l3的时候需要隐藏的mesh数组
  // commonNeedHideMesh II型及U型柜正常展示的时候需要隐藏的mesh数组
  // XNeedShowMesh II型及U型柜隐藏l1的时候需要展示的mesh数组   踢脚板及台面都有三个模型控制显隐的
  // P2XNeedShowMesh II型及U型柜隐藏l3的时候需要展示的mesh数组
  // renderUThis.topPanelMesh = [topPanel.mesh, topPanel2.mesh, topPanel3.mesh, topPaneHideL3.mesh, topPaneHideL1.mesh];
  // renderUThis.topPanelObjs = [topPanel, topPanel2, topPanel3, topPaneHideL3, topPaneHideL1];
  renderUThis.topPanelMesh = [...renderUThis.topPanelMesh, topPaneHideL3.mesh, topPaneHideL1.mesh];
  renderUThis.topPanelObjs = [...renderUThis.topPanelObjs, topPaneHideL3, topPaneHideL1];
  // U型L3边为40深且L2边没有柜体，需要隐藏L1和L3
  if (bottomType === BASICRENDER_TYPE.U_S && hasLength2.length === 0) {
    // renderUThis.XNeddHideMesh = [...renderUThis.XNeddHideMesh, topPaneHideL3.mesh,
    //   topPanel.mesh, topPanel2.mesh, topPanel3.mesh];
    renderUThis.XNeddHideMesh = [...renderUThis.XNeddHideMesh, topPaneHideL3.mesh, lastTopPanelLength3.mesh];
    topPanelArrLength1.forEach((item) => {
      renderUThis.XNeddHideMesh.push(item.mesh);
    });
    topPanelArrLength2.forEach((item) => {
      renderUThis.XNeddHideMesh.push(item.mesh);
    });
    if (topPaneUSHideL3) {
      renderUThis.XNeedShowMesh = [...renderUThis.XNeedShowMesh, topPaneUSHideL3.mesh];
      renderUThis.commonNeedHideMesh = [...renderUThis.commonNeedHideMesh, topPaneHideL1.mesh,
        topPaneHideL3.mesh, topPaneUSHideL3.mesh];
    } else {
      renderUThis.XNeedShowMesh = [...renderUThis.XNeedShowMesh];
      renderUThis.commonNeedHideMesh = [...renderUThis.commonNeedHideMesh, topPaneHideL1.mesh, topPaneHideL3.mesh];
    }
  } else {
    // renderUThis.XNeddHideMesh = [...renderUThis.XNeddHideMesh, topPaneHideL3.mesh, topPanel.mesh, topPanel2.mesh];
    renderUThis.XNeddHideMesh = [...renderUThis.XNeddHideMesh, topPaneHideL3.mesh];
    topPanelArrLength1.forEach((item) => {
      renderUThis.XNeddHideMesh.push(item.mesh);
    });
    if ((l2HighSinkCabinetFrame?.frameInfo && l2HighSinkCabinetFrame?.isAfterDirection === true
      && sinkPositionInfo.location === 3 && stovePositionInfo?.location === 2) || (
      l2HighSinkCabinetFrame?.frameInfo && l2HighSinkCabinetFrame?.isAfterDirection === false
      && sinkPositionInfo.location === 2 && stovePositionInfo?.location === 3
    ) || (l2HighSinkCabinetFrame?.frameInfo && l2HighSinkCabinetFrame?.isAfterDirection === false
      && sinkPositionInfo.location === 1 && stovePositionInfo?.location === 3 && hasLength2.length > 1)) {
      // L1=168, L2=238, L3=238, 高低台面，水槽在L3，灶台在L2，隐藏L1边时只需隐藏L2的第一块低台面
      // L1=168, L2=238, L3=168, 水槽在L1，灶台在L3, L2边至少两个柜体
      renderUThis.XNeddHideMesh.push(topPanelArrLength2[0]?.mesh);
    } else {
      topPanelArrLength2.forEach((item) => {
        renderUThis.XNeddHideMesh.push(item.mesh);
      });
    }
    renderUThis.XNeedShowMesh = [...renderUThis.XNeedShowMesh, topPaneHideL1.mesh];
    renderUThis.commonNeedHideMesh = [...renderUThis.commonNeedHideMesh, topPaneHideL1.mesh, topPaneHideL3.mesh];
  }
  // renderUThis.P2XNeddHideMesh = [...renderUThis.P2XNeddHideMesh, topPaneHideL1.mesh, topPanel2.mesh, topPanel3.mesh];
  renderUThis.P2XNeddHideMesh = [...renderUThis.P2XNeddHideMesh, topPaneHideL1.mesh];
  if (l2HighSinkCabinetFrame && l2HighSinkCabinetFrame.frameInfo) {
    if (bottomType === BASICRENDER_TYPE.U && ((l2HighSinkCabinetFrame.isAfterDirection === false
        && sinkPositionInfo.location === 1 && stovePositionInfo?.location === 2) || (
      l2HighSinkCabinetFrame.isAfterDirection === true
          && sinkPositionInfo.location === 2 && stovePositionInfo?.location === 1
    ) || (l2HighSinkCabinetFrame.isAfterDirection === true
      && sinkPositionInfo.location === 3 && stovePositionInfo?.location === 1 && hasLength2.length > 1))) {
      // 高低台面分段点在L2，灶台在L2，水槽在L1，L2左低右高，旋转隐藏L3时L2边只需隐藏最后一块低台面
      // L1=238, L2=196, L3=238, 灶台在L2，水槽在L1，L2左低右高，也满足该条件但是为U_S, L3是40深窄柜, L2需要全部隐藏
      // L1=168, L2=300, L3=238, 灶台在L1，水槽在L2
      // L1=168, L2=228, L3=238, 灶台在L1，水槽在L3, L2边至少两个柜体
      renderUThis.P2XNeddHideMesh.push(topPanelArrLength2[topPanelArrLength2.length - 1]?.mesh);
    }
    if ((bottomType === BASICRENDER_TYPE.U_S && hasLength2.length > 0 && stovePositionInfo?.location === 2) || (
      bottomType === BASICRENDER_TYPE.U && (
        (l2HighSinkCabinetFrame.isAfterDirection === false
           && (sinkPositionInfo.location === 1 || sinkPositionInfo.location === 2)
           && stovePositionInfo?.location === 3) || (
          l2HighSinkCabinetFrame.isAfterDirection === true
      && sinkPositionInfo.location === 3 && stovePositionInfo?.location === 2
        ) || (l2HighSinkCabinetFrame.isAfterDirection === true
          && sinkPositionInfo.location === 3 && stovePositionInfo?.location === 1 && hasLength2.length === 1))
    )) {
      // L1=238, L2=174, L3=238, 灶台在L2, 水槽在L1, 旋转隐藏L3时L2边需隐藏原先所有台面
      // L1=238, L2=208, L3=128, 灶台在L3, 水槽在L1
      // L1=238, L2=208, L3=128, 灶台在L2, 水槽在L3
      // L1=128, L2=266, L3=158, 灶台在L1, 水槽在L3, L2边只有一个转角柜
      topPanelArrLength2.forEach((item) => {
        renderUThis.P2XNeddHideMesh.push(item.mesh);
      });
    }
  } else {
    topPanelArrLength2.forEach((item) => {
      renderUThis.P2XNeddHideMesh.push(item.mesh);
    });
  }
  topPanelArrLength3.forEach((item) => {
    renderUThis.P2XNeddHideMesh.push(item.mesh);
  });
  renderUThis.P2XNeedShowMesh = [...renderUThis.P2XNeedShowMesh, topPaneHideL3.mesh];
}


export default renderTopPanelUtil;
